import React, { useContext, useMemo } from 'react';
import displayDataContext from '../contexts/displayData';
import providersContext from '../contexts/providers';
import favoriteItemsContext from '../contexts/favoriteItems';

const { Provider } = displayDataContext;

export default (WrappedComponent) => () => {
  const { providers } = useContext(providersContext);
  const { favoriteItems } = useContext(favoriteItemsContext);

  const displayData = useMemo(() => {
    const likedProviderIds = [];
    const likedProductIds = [];
    const dislikedProductIds = [];

    favoriteItems.forEach((item) => {
      const { itemId: id, itemType, type } = item || {};

      if (type === 'LIKE' && itemType === 'PROVIDER') likedProviderIds.push(id);
      if (type === 'LIKE' && itemType === 'PRODUCT') likedProductIds.push(id);
      if (type === 'DISLIKE' && itemType === 'PRODUCT') dislikedProductIds.push(id);
    });

    return providers.map((provider) => {
      const { encodedProviderName, products } = provider || {};

      return {
        ...provider,
        isLiked: likedProviderIds.includes(encodedProviderName),
        products: (products || []).map((product) => {
          const { id } = product || {};

          return {
            ...product,
            isLiked: likedProductIds.includes(id),
            isDisliked: dislikedProductIds.includes(id),
          };
        }),
      };
    });
  }, [providers, favoriteItems]);

  return (
    <Provider value={{ displayData }}>
      <WrappedComponent />
    </Provider>
  );
};
